import ToggleSwitch from '@/comp/toggleSwitch/toggleSwitch';
import BookingData, { FlightSegment } from '@/model/common/BookingData';

export type PostPayServices = 'hotel' | 'flight' | 'cruise';

export const ChangeMediatedPostpay = ({
    bookingData,
    setBookingData,
}: {
    bookingData: BookingData;
    setBookingData: (bookingData: BookingData) => void;
}) => {
    const changeHotel = (type: 'postPay' | 'mediated', value: boolean) => {
        const frontendParams = bookingData.data.frontendParams;
        const hotelDetails = frontendParams.hotelDetails;
        if (hotelDetails) {
            hotelDetails.forEach((hotel) => {
                if (type === 'mediated') {
                    hotel.mediated = value;
                    frontendParams.mediatedServices.accommodation = value;
                } else if (type === 'postPay') {
                    hotel.postPay = value;
                    frontendParams.postPayServices.accommodation = value;
                }
            });
            setBookingData({ ...bookingData });
        }
    };

    const changeFlight = (type: 'postPay' | 'mediated', value: boolean) => {
        const frontendParams = bookingData.data.frontendParams;
        const flightDetails = frontendParams.flightDetails;
        Object.values(flightDetails).forEach((segments: FlightSegment[]) => {
            segments.forEach((segment) => {
                if (type === 'mediated') {
                    segment.mediated = value;
                    frontendParams.mediatedServices.transport = value;
                } else if (type === 'postPay') {
                    segment.postPay = value;
                    frontendParams.postPayServices.transport = value;
                }
            });
        });
        setBookingData({ ...bookingData });
    };

    const changeCruise = (type: 'postPay' | 'mediated', value: boolean) => {
        const frontendParams = bookingData.data.frontendParams;
        const cruiseDetails = frontendParams.cruise;
        if (cruiseDetails) {
            if (type === 'mediated') {
                cruiseDetails.mediated = value;
                frontendParams.mediatedServices.cruise = value;
            } else if (type === 'postPay') {
                cruiseDetails.postPay = value;
                frontendParams.postPayServices.cruise = value;
            }
            setBookingData({ ...bookingData });
        }
    };

    const handleChange = (service: PostPayServices, type: 'mediated' | 'postPay', value: boolean) => {
        if (service === 'hotel') {
            changeHotel(type, value);
        } else if (service === 'flight') {
            changeFlight(type, value);
        } else if (service === 'cruise') {
            changeCruise(type, value);
        }
    };

    return (
        <div>
            <h2>Mediated/Postpay Manipulation</h2>
            {bookingData.data.frontendParams.hotelDetails && (
                <div className="mediated-selection">
                    Unterkunft
                    <div>
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.mediatedServices.accommodation}
                            onChange={(value) => handleChange('hotel', 'mediated', value)}
                            label="mediated (vermittelt)"
                        />
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.postPayServices.accommodation}
                            onChange={(value) => handleChange('hotel', 'postPay', value)}
                            label="postpay"
                        />
                    </div>
                </div>
            )}
            {bookingData.data.frontendParams.flightDetails && (
                <div className="mediated-selection">
                    Flug
                    <div>
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.mediatedServices.transport}
                            onChange={(value) => handleChange('flight', 'mediated', value)}
                            label="mediated (vermittelt)"
                        />
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.postPayServices.transport}
                            onChange={(value) => handleChange('flight', 'postPay', value)}
                            label="postpay"
                        />
                    </div>
                </div>
            )}
            {bookingData.data.frontendParams.cruise && (
                <div className="mediated-selection">
                    Cruise
                    <div>
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.mediatedServices.cruise}
                            onChange={(value) => handleChange('cruise', 'mediated', value)}
                            label="mediated (vermittelt)"
                        />
                        <ToggleSwitch
                            checked={bookingData.data.frontendParams.postPayServices.cruise}
                            onChange={(value) => handleChange('cruise', 'postPay', value)}
                            label="postpay"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
